import { CSSObject } from '@mui/material';

export const fontSecondaryOblique: CSSObject = {
	fontFamily: "'Roboto', sans-serif",
	fontStyle: 'italic',
	fontWeight: 400,
};
export const fontPrimaryBold: CSSObject = {
	fontFamily: "'Ubuntu', sans-serif",
	fontWeight: 'bold',
};
